module.exports = __webpack_public_path__ + "assets_1713491368921/img/guide_ios.431fc979.png";